import React from 'react';
import classnames from 'classnames';
import styles from './Tags.module.scss';

export interface TagsProps {
  className?: string;
  tags: string[];
  /** Base style applied to all tags */
  tagStyle?: React.CSSProperties;
  /** Higher priority: style resolver per tag */
  getTagStyle?: (tag: string, index?: number) => React.CSSProperties | undefined;
  renderTagName?: (tag: string) => string;
}

export const Tags: React.FC<TagsProps> = ({
  className,
  tags,
  tagStyle,
  getTagStyle,
  renderTagName = (tag: string) => tag,
}) => {
  if (!tags?.length) return null;

  return (
    <div className={classnames(styles.root, className)}>
      {tags.map((tag, index) => (
        <div
          key={`${tag}-${index}`}
          className={styles.item}
          style={{ ...tagStyle, ...(getTagStyle?.(tag, index) || {}) }}
        >
          {renderTagName(tag)}
        </div>
      ))}
    </div>
  );
};
